<style scoped lang="less" src="./../assets/GoTop.less"></style>
<template>
  <div class="gotop" @click="goTop" :style="{display: show ? 'block' : 'none'}"></div>
</template>
<script>
  export default {
    name: 'GoTop',
    data() {
      return {
        show: false
      };
    },
    props: ['trackInfo'],
    watch: {
      show() {
//        const $el = window.$('.gotop');
//        if (this.show) {
//          $el.fadeIn();
//        } else {
//          this.show = false;
//        }
      }
    },
    mounted() {
      let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
      this.show = scrolltop > document.body.clientHeight;
      window.onscroll = () => {
        scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrolltop > document.body.clientHeight) {
          this.show = true;
//          if (this.trackInfo) {
//            window.Track.doPublicTracker(1, {
//              url: this.trackInfo.url,
//              trackerCode: this.trackInfo.showTrackerCode,
//              href: this.trackInfo.be
//            });
//          }
        } else {
          this.show = false;
        }
      };
    },
    methods: {
      goTop() {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        this.show = false;
        if (this.trackInfo) {
          window.Track.doPublicTracker(2, {
            url: this.trackInfo.url,
            trackerCode: this.trackInfo.trackerCode,
            href: this.trackInfo.be
          });
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// GoTop.vue?3bacc1cf